import { useCallback, useEffect, useState } from "react";
import { Grid, Button, TextField, IconButton } from "@mui/material";
import { useParams } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import BackButton from "components/shared/BackButton";
import { StyledStack, StyledTitle, ButtonContainer } from "./AddProduct.style";
import DrawerCM from "components/shared/Drawer";
import { prodcutColorSchema } from "validations";
import TableCM from "components/shared/Table";
import { addProductColorRequest, getProductsColorRequest } from "api/requests";
import useHttp from "hooks/use-http";
import LoadingCM from "components/shared/Loading";
import Toast from "helper/toast";
import { PAGINATION_LIMIT } from "constants";
import GenarateHeadCell from "helper/generate-head-cell";
import PaginationCM from "components/shared/Pagination";
import { Link } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { FaImages } from "react-icons/fa";

const headCells = GenarateHeadCell("productsColor");
let initialPage = 1;

//////////////////////////
const formList = [
  { label: "نام رنگ", type: "text", id: "title", required: true },
  { label: "انتخاب رنگ", type: "color", id: "color_code", required: true },
  { label: "تعداد", type: "text", id: "stock", required: true },
];

export default function AddColors() {
  const params = useParams();
  const { request, loading } = useHttp(false);
  const {
    register,
    handleSubmit,
    control,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(prodcutColorSchema),
  });
  const [page, setPage] = useState(initialPage);
  const [colors, setColors] = useState({ data: [], count: 0 });

  /////////////get Products/////////////
  const getColors = useCallback(async () => {
    const res = await request({
      url: getProductsColorRequest,
      values: {
        skip: (page - 1) * PAGINATION_LIMIT,
        limit: PAGINATION_LIMIT,
        product_id: params.productId,
      },
    });

    if (res.count < 1) {
      return setColors({
        count: res.count,
        data: [{ content: "هیچ رنگی یافت نشد" }],
      });
    }
    if (res) {
      let transformedData = res.data.map((items) => ({
        id: items.id,
        title: items.title,
        color_code: (
          <div
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "100%",
              background: `${items.color_code}`,
            }}
            title={items.color_code}
          ></div>
        ),
        stock: items.stock,
        edit: (
          <Link to={`/color/edit/${items.id}`}>
            <IconButton color="primary">
              <EditIcon />
            </IconButton>
          </Link>
        ),
        image: (
          <Link to={`/product/image/${items.id}`}>
            <IconButton color="primary">
              <FaImages />
            </IconButton>
          </Link>
        ),
      }));
      setColors({ data: transformedData, count: res.count });
    }
  }, [page, request]);

  useEffect(() => {
    getColors();
  }, [page, getColors]);

  ////////////////// submit form /////////////////
  const onSubmit = async (values) => {
    const transformedData = {
      title: values.title,
      color_code: values.color_code,
      stock: values.stock,
      product_id: params.productId,
    };
    const res = await request({
      url: addProductColorRequest,
      values: transformedData,
    });

    if (res) {
      Toast({ type: "success", title: "افزودن رنگ" });
      reset({
        title: "",
        color_code: "",
        stock: "",
      });
      getColors();
    }
  };

  return (
    <DrawerCM title="افزودن رنگ">
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container my={2}>
          <Grid item mb={-2} xs={12}>
            <BackButton />
          </Grid>
          <StyledStack>
            <StyledTitle>افزودن رنگ</StyledTitle>
            <Grid container>
              {formList.map((items, index) => (
                <Grid
                  item
                  md={[2].includes(index) ? 12 : 6}
                  xs={12}
                  p={1}
                  key={"add-product" + index}
                >
                  <TextField
                    id={items.id}
                    label={items.label}
                    type={items.type}
                    variant="outlined"
                    required={items.required}
                    fullWidth
                    multiline={items.id === "description"}
                    rows={items.id === "description" ? 6 : 1}
                    {...register(items.id)}
                    error={Boolean(errors[items.id])}
                    helperText={errors[items.id]?.message}
                  />
                </Grid>
              ))}

              <ButtonContainer>
                <Button
                  color="success"
                  startIcon={<CheckIcon />}
                  variant="contained"
                  sx={{ mt: 1, mr: 1 }}
                  onClick={handleSubmit(onSubmit)}
                >
                  ثبت
                </Button>
              </ButtonContainer>
            </Grid>
          </StyledStack>
          <Grid item xs={12} my={2}>
            <TableCM
              title="لیست رنگ ها"
              rows={colors.data}
              headCells={headCells}
              page={page}
            />
          </Grid>
          <PaginationCM
            handleChange={(e, val) => {
              initialPage = val;
              setPage(val);
            }}
            page={page}
            count={colors.count}
          />
        </Grid>
      )}
    </DrawerCM>
  );
}
